import * as React from 'react';
import { faFileArrowDown } from '@fortawesome/pro-regular-svg-icons';

import Button from '../../atoms/Button';
import DropdownButton, { DropdownButtonItemProps } from '../DropdownButton';

export interface Props extends Omit<DropdownButtonItemProps, 'variant'> {
  ext?: Array<'csv' | 'xls'>;
  disabled?: boolean;
  onExport: (type: 'csv' | 'xls') => void;
}

interface Option {
  id: 'csv' | 'xls';
  label: string;
}

const defaultOptions: Array<Option> = [
  { label: 'CSV', id: 'csv' },
  { label: 'XLS', id: 'xls' },
];

const ItemComponent = (props: DropdownButtonItemProps) => (
  <Button variant="link" {...props} />
);

export const ExportButton: React.FunctionComponent<Props> = ({
  ext = ['csv', 'xls'],
  disabled = false,
  onExport,
  ...htmlElementProps
}) => {
  const options = React.useMemo(
    () => defaultOptions.filter((opt) => ext.includes(opt.id)),
    [ext],
  );

  return (
    <DropdownButton
      variant="link"
      icon={faFileArrowDown}
      label="Exportar"
      options={options}
      disabled={disabled}
      onSelect={(id) => onExport(id)}
      itemComponent={ItemComponent}
      hideChevron
      {...htmlElementProps}
    />
  );
};

export default ExportButton;
